import { Trans } from "react-i18next";import { ChevronRight } from "lucide-react";
import { LeaveStatusBadge } from "./LeaveStatusBadge";
import { normalizeStatus } from "../../../lib/leaveRecords";

export function ManagerLeaveMobileList({ rows, resolveEmployeeInfo, onSelect }) {
  return (
    <ul className="divide-y divide-(--color-text-border)/35 md:hidden">
      {rows.map((row) => {
        const employee = resolveEmployeeInfo(row.empId, row);
        const status = normalizeStatus(row.leaveStatus);

        return (
          <li key={row.leaveId}>
            <button
              type="button"
              onClick={() => onSelect(row)}
              className="flex w-full items-center gap-3 px-4 py-3.5 text-left hover:bg-workspace/20 transition-colors cursor-pointer">
              
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-foreground truncate">{employee.name}</p>
                <div className="mt-1.5">
                  <LeaveStatusBadge status={status} />
                </div>
              </div>
              <ChevronRight className="h-4 w-4 shrink-0 per-file-hint" aria-hidden="true" />
              <span className="sr-only"><Trans i18nKey="formActions.viewLeaveRequestDetails" /></span>
            </button>
          </li>);

      })}
    </ul>);

}
